<template>
  <WithdrawRequest />
  <!-- <OfflineRequest /> -->
</template>

<script>
import WithdrawRequest from '@/components/WithdrawRequest'
// import OfflineRequest from '@/components/WithdrawRequest/offline.vue'

export default {
  components: {
    WithdrawRequest,
    // OfflineRequest,
  },
}
</script>
